/**
 * Default width for Table components.
 */
export const TABLE_WIDTH_DEFAULT = 0;
